import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { PermissionService } from './permission.service';

@Directive({
  selector: '[appPermission]',
  exportAs: 'appPermission',
})
export class PermissionDirective implements OnInit {
  @Input() muOption: string;
  @Input() muDisabledClass = 'mu-field-disabled-action';

  constructor(private renderer: Renderer2, private elementRef: ElementRef, private permissionService: PermissionService) {
    /** */
  }

  async ngOnInit(): Promise<void | boolean> {
    if (await this.permissionService.canAccess(this.muOption)) {
      return true;
    }
    const element = this.elementRef.nativeElement;
    if (element instanceof HTMLInputElement) {
      element.disabled = true;
    }
    this.renderer.addClass(this.elementRef.nativeElement, this.muDisabledClass);
  }
}
